module.exports = __webpack_public_path__ + "static/media/PowerConsumption[1].c0f65fd7.png";